module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/iG7DCH/tc-custom/9781540260796.jpg?1719575728552",
      "alt": "This image is the cover for the book Hot Rodding in the San Fernando Valley, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hot Rodding in the San Fernando Valley, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This book chronicles the once-vibrant hot rod scene in California's San Fernando Valley--from the iconic Bob's Big Boy drive-in to the San Fernando drag strip.  Author and Los Angeles native, Tony Baker, grew up in Hollywood during the height of the sixties hot-rod scene. He has written six books on the subject of motor sports in California for Arcadia Publishing and has had articles published in Hot Rod magazine, Hot Rod Deluxe , and Rodder's Journal as well as regional history publications like the Ventura County Historical Society Quarterly Journal . He currently lives in Ventura, California.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mr. Tony T. Baker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Los Angeles native Tony Baker grew up in Hollywood during the height of the sixties hot-rod scene. He has written six books on the subject of motor sports in California for Arcadia Publishing and has had articles published in Hot Rod magazine, Hot Rod Deluxe , and Rodder's Journal as well as regional history publications like the Ventura County Historical Society Quarterly Journal . He currently lives in Ventura, California.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0